module.exports = __webpack_public_path__ + "static/media/logo.bd81261c.png";